// apiUrls.js
export const API_URLS = {


  // GET_ALL_REPORTS:()=>`api/admin/project/allReport?page=1&limit=10&client_id=6847e833ad39eb63d41ccd67&project_id=68dbb9048644d643d3e631c1`,


  GET_ALL_REPORTS: (pageNo, pageSize, search, projectId, clientId) =>
    `/api/admin/project/allReport?page=${pageNo}&limit=${pageSize}&search=${search}&project_id=${projectId}&client_id=${clientId}`,

  UPDATE_STANDARD_FORM_STATUS: (formId) =>
    `/api/admin/form-template/update/${formId}`,

  SEND_STANDARD_FORM_FOR_APPROVAL: (formId) =>
    `/api/admin/form-template/approve/${formId}`,

  CUSTOMFORM_SECTIONS: (formId) =>
    `/api/admin/client/custom-form/sections/${formId}`, // Get sections of a custom form
  CUSTOMFORM_SUBSECTIONS: (formId, sectionId) =>
    `/api/admin/client/custom-form/subsections?formId=${formId}&sectionId=${sectionId}`, // Get subsections of a custom form
  CUSTOMFORM_QUESTIONS: (formId, sectionId, subsectionId) =>
    `/api/admin/client/custom-form/questions?formId=${formId}&sectionId=${sectionId}&subsectionId=${subsectionId}`, // Get questions of a custom form
  GET_SECTIONS: (page, pageSize, createdAt) =>
    `/api/admin/custom-section/get?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}`,
  GET_SUBSECTIONS: (sectionId) =>
    `/api/admin/custom-subsection/getByCustomSection/${sectionId}`,
  GET_CUSTOM_QUESTION: (page, search, filterData) =>
    `/api/admin/customQuestions/all?page=${page}&search=${search}&filter=${encodeURIComponent(
      JSON.stringify(filterData || {})
    )}`, //API to get all question
  QUESTIONS_GETALL: "/api/admin/questions/all", // Example: Get all questions
  QUESTIONS_SECTION: (id) => `/api/admin/questions/section/${id}`, // Dynamic: Get section by ID
  QUESTIONS_SUBSECTION: (id) => `/api/admin/questions/subsection/${id}`, // Dynamic: Get subsections by ID
  GET_QUESTION_OPTIONS: (questionId) =>
    `/api/admin/questions/options/${questionId}`, // Get options for a question
  GET_TABLE_ROW_TYPE_DEFINITION: (tableRowTypeId) =>
    `/api/admin/questions/table-row-type/${tableRowTypeId}`, // Get table row definition




  LOGIN_CLIENT: "/api/client/auth/login", // API endpoint for client login
  LOGIN: "/api/auth/admin/login",
  SIGN_UP_CLIENT: "/api/client/auth/signup", // API endpoint for client signup
  OTP_EMAIL: "/api/client/auth/verification-mail", //// API endpoint for client mail otp,
  VALIDATE_SWITCH_TOKEN: "/api/client/auth/validate-switch-token", // API endpoint for validate Switch Token
  CREATE_SWITCH_REQUEST: "/api/client/auth/create-switch-request", // API endpoint for create-switch-request
  LOGIN_EMPLOYEE: "/api/user/auth/login", // API endpoint for employee login
  QUESTIONBANK_OVERVIEW: "/api/admin/questions/overview",
  OVERVIEW_SECTION: (id) => `/api/admin/questions/section/overview/${id}`,
  GET_SIDEBAR_ACCESS: `/api/admin/auth/sidenav`,
  GETALL_PROJECTS: (page, pageSize, createdAt, projectName, filterData) =>
    `/api/admin/project/get?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}&search=${projectName}&filter=${encodeURIComponent(
      JSON.stringify(filterData || {})
    )}`,

  GET_PROJECT_BY_ID: ({ projectId }) => `/api/admin/project/get/${projectId}`,

  GET_PROJECTS: (page, pageSize, name = "") => {
    let url = `/api/admin/project/get?limit=${pageSize}&skip=${(page - 1) * pageSize
      }&sort=-createdAt`;
    if (name) {
      url += `&name=${encodeURIComponent(name)}`;
    }
    return url;
  },
  CREATE_PROJECT: `/api/admin/project/create`,
  UPDATE_PROJECT: (projectId) => `/api/admin/project/update/${projectId}`,

  ALL_QUESTIONSPERSECTION: (limit) =>
    `/api/admin/questions/sections?pageSize=${limit}`,
  ALL_SECTIONS: (currentPage, limit, searchTerm = "") =>
    `/api/admin/questions/sections?pageNo=${currentPage}&pageSize=${limit}&search=${encodeURIComponent(
      searchTerm
    )}`,

  SUBSECTION_BY_ID: (subsectionId, currentPage, limit, searchTerm = "") =>
    `/api/admin/questions/subsection/${subsectionId}?pageNo=${currentPage}&pageSize=${100}&search=${encodeURIComponent(
      searchTerm
    )}`,

  // QUESTIONS_BY_SUBSECTION: (subSectionId, searchTerm = "") =>
  //   `/api/admin/questions/getBySubsection/${subSectionId}?search=${encodeURIComponent(
  //     searchTerm
  //   )}`,

  QUESTIONS_BY_SUBSECTION: (subSectionId, searchTerm = "", pageSize = 100) =>
    `/api/admin/questions/getBySubsection/${subSectionId}?search=${encodeURIComponent(
      searchTerm
    )}&pageSize=${pageSize}`,

  ALL_QUESTIONSPERSECTION: (limit) =>
    `/api/admin/questions/sections?pageSize=${limit}`,

  CREATE_STANDARDFORMS: "/api/admin/form-template/create",
  GET_STANDARDFORMS: (pageSize, page, createdAt, searchTerm = "") =>
    `/api/admin/form-template/get?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}&search=${encodeURIComponent(searchTerm)}`,
  GET_ACTIVE_STANDARDFORMS: (
    pageSize = 25,
    page,
    filters = {},
    createdAt = "createdAt"
  ) =>
    `/api/admin/form-template/get?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}&status=Approved`,

  GET_STANDARD_FORM_BY_ID: (formId) => `/api/admin/form-template/get/${formId}`,
  GET_SECTION_SUBSECTION_BY_FORMID: (formId) =>
    `/api/admin/client/form/get-section-subsection/${formId}`,
  GET_CUSTOM_SECTIONS_BY_FORMID: (formId) =>
    `/api/admin/client/custom-form/sections/${formId}`,
  GET_STANDARD_SECTIONSBY_ID: (formId) =>
    `/api/admin/form-template/sections/${formId}`,
  GET_STANDARD_SUBSECTION_BY_ID: (formId, sectionId) =>
    `/api/admin/form-template/subsections?formId=${formId}&sectionId=${sectionId}`,
  GET_STANDARD_SUBSECTIONQUESTIONS_BY_ID: (formId, sectionId, subsectionId) =>
    `/api/admin/form-template/questions?formId=${formId}&sectionId=${sectionId}&subsectionId=${subsectionId}`,

  GET_USER_DETAIL_STANDARD_SECTIONS: (formId) =>
    `/api/admin/project/get-standard-sections/${formId}`,
  GET_USER_DETAIL_STANDARD_SUBSECTIONS: (formId, sectionId) =>
    `/api/admin/project/get-standard-subsections?formId=${formId}&sectionId=${sectionId}`,
  GET_USER_DETAIL_STANDARD_QUESTIONS: (formId, sectionId, subsectionId) =>
    `/api/admin/project/get-standard-questions?formId=${formId}&sectionId=${sectionId}&subsectionId=${subsectionId}`,
  GET_PROJECT_ANSWERS: (allotmentId, sectionId, subSectionId, userId) => {
    const params = new URLSearchParams({
      UserId: userId || "",
      standardFormAllotmentId: allotmentId || "",
      sectionId: sectionId || "",
      subSectionId: subSectionId || "",
    });

    return `/api/admin/project/get-answers?${params.toString()}`;
  },

  GET_STANDARD_FORM_BY_PROJECTID: (projectId, search, pageNo, pageSize) =>
    `/api/admin/project/get/standard-form/${projectId}?search=${search}&pageNo=${pageNo}&limit=${pageSize}&skip=${(pageNo - 1) * pageSize
    }`,
  GET_CUSTOM_FORM: `/api/admin/client/custom-form/getAll`,
  UPDATE_STANDARDFORM_STATUS: (id) => `/api/admin/form-template/update/${id}`,
  GET_STANDARDFORMS: (pageSize, page, createdAt, searchTerm = "") =>
    `/api/admin/form-template/get?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}&search=${encodeURIComponent(searchTerm)}`,
  ALL_SECTIONS_STANDARD: (currentPage, limit, searchTerm = "") =>
    `/api/admin/questions/sections?pageNo=${currentPage}&pageSize=${limit}&search=${encodeURIComponent(
      searchTerm
    )}`,
  GET_CUSTOM_FORM_BY_PROJECTID: (projectId) =>
    `/api/admin/project/get/custom-form/${projectId}`,
  GET_ALL_CUSTOMFORMS: `/api/admin/client/custom-form/getAll`,
  GET_DYNAMIC_FORM_BY_CLIENTID: (clientId) =>
    `/api/admin/custom-template/user-templates/${clientId}`,
  ADDNEW_CUSTOM_FORM_BY_PROJECTID: (projectId) =>
    `/api/admin/project/add-dynamic-form/${projectId}`,

  GET_ALL_USERS_BY_CLIENTID: (clientId, pageSize, page, createdAt, search, filter = {}) => {
    const cleanFilter = Object.fromEntries(
      Object.entries(filter).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
    );
    const params = new URLSearchParams({
      client_id: clientId,
      limit: pageSize,
      search: search || "",
      skip: (page - 1) * pageSize,
      sort: createdAt,
      ...cleanFilter
    });
    return `/api/admin/project/getUser?${params.toString()}`;
  },
  GET_STANDARDFORM_ASSIGNED_USER: (
    projectId,
    templateId,
    clientId,
    pageSize,
    page,
    createdAt
  ) =>
    `/api/admin/project/getUser-standardFormAllotment?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}&client_id=${clientId}&projectId=${projectId}&templateId=${templateId}`,
  GET_CUSTOMFORM_ASSINGED_USER: (
    templateId,
    clientId,
    pageSize,
    page,
    createdAt
  ) =>
    `/api/admin/project/getUser-customFormAllotment?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}&client_id=${clientId}&templateId=${templateId}`,
  GET_USER_BY_USERID: (userId, search, limit, skip) =>
    `/api/admin/client/project/user-detail?user_id=${userId}&search=${search}&limit=${limit}&skip=${skip}`,
  GET_ALL_PROJECT_TYPES: `/api/admin/projectType/list`,

  CREATE_PROJECT_SETUP: (projectId) => `/api/admin/project/set-up/${projectId}`,


  // USERS_GETALL: (pageNo, pageSize, searchTerm = "") =>
  //   `/api/admin/auth/user-list?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(
  //     searchTerm
  //   )}`,
  CREATE_USER: "/api/admin/auth/add-user",
  EDIT_USER: (id) => `/api/admin/auth/edit-user/${id}`,
  DELETE_USER: (id) => `/api/admin/auth/delete/${id}`,

  ALL_PROJECT_TYPES: (pageNo, pageSize, searchTerm = "") =>
    `/api/admin/projectType/list?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(
      searchTerm
    )}`,

  ALL_REPORT_TYPES: (page, limit, searchTerm = "") =>
    `/api/admin/report/allReport?page=${page}&limit=${limit}&search=${encodeURIComponent(
      searchTerm
    )}`,

  GET_ALL_CUSTOMER_REPORTS: (page, limit, search = "") =>
    `/api/admin/report/getallcustomerReport?page=${page}&limit=${limit}&search=${search}`,

  GET_CUSTOMER_REPORT_DETAILS: (id) => `/api/admin/report/getCustomerReport/${id}`,
  CREATE_REPORT_REQUEST: (id) => `/api/admin/report/create-reportRequest/${id}`,
  DELETE_REPORT_REQUEST: (reportId, id) =>
    `/api/admin/report/delete-reportRequest/${reportId}/${id}`,

  UPLOAD_REPORT_REQUEST: (reportId, id) => `/api/admin/report/update-reportRequest/${reportId}/${id}`,


  ADD_PROJECT_TYPE: "/api/admin/projectType/create",
  ADD_REPORT_TYPE: "/api/admin/report/create",
  EDIT_PROJECT_TYPE: (id) => `/api/admin/projectType/edit/${id}`,
  DELETE_PROJECT_TYPE: (id) => `/api/admin/projectType/delete/${id}`,
  DELETE_REPORT_TYPE: (id) => `/api/admin/report/deleteReport/${id}`,
  ALL_LICENSE_COSTS: "/api/admin/licenseCost/list",
  EDIT_LICENSE_COST: (id) => `/api/admin/licenseCost/edit/${id}`,
  //  /api/admin/report/updateReport/68e4e5d3a0266cd61cda3d79
  // /api/admin/report/getReport/68e500c20f3f5f13f327bec9
  GET_REPORT_TYPE: (id) => `/api/admin/report/getReport/${id}`,
  UPDATE_REPORT_TYPE: (id) => `api/admin/report/updateReport/${id}`,
  ALL_ROLES: "/api/admin/roles",
  CREATE_ROLE: "/api/admin/roles/create",
  ROLE_BY_ID: (roleId) => `/api/admin/roles/${roleId}`,
  DELETE_ROLE: (roleId) => `/api/admin/roles/${roleId}`,
  EDIT_ROLE: (roleId) => `/api/admin/roles/${roleId}`,
  ALL_STATIC_PAGES: (pageNo, pageSize, searchTerm = "") =>
    `/api/admin/content/all-content?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(
      searchTerm
    )}`,
  CREATE_STATIC_PAGE: "/api/admin/content/create",
  EDIT_STATIC_PAGE: (id) => `/api/admin/content/${id}`,
  COPY_STANDARD_FORM: (id) => `/api/admin/form-template/copy/${id}`,

  //Customer API's
  ADD_NEW_CUSTOMER: "/api/auth/client/signup",
  CUSTOMER_OTP_GENERATE:
    "/api/admin/customer/carburn/signup/generateCarburnotp",
  CUSTOMER_VERIFY_OTP: "/api/auth/client/carburn/signup/verifyCarburnotp",
  GET_CUSTOMER_LIST: "/api/admin/customer/get-all-customers",
  GET_ALL_CUSTOMER: (page, pageSize, createdAt, projectName, status) => {
    const params = new URLSearchParams();
    params.append("limit", String(pageSize));
    params.append("skip", String((page - 1) * pageSize));
    if (createdAt) params.append("sort", createdAt);
    if (projectName) params.append("search", projectName);
    if (status === "Active" || status === "Inactive") {
      params.append("status", status);
    }
    return `/api/admin/customer/get-all-customers?${params.toString()}`;
  },
  GET_SECTION_BY_FORMID: (formId, pageSize = 5) =>
    `/api/admin/form/section?section=section1&id=${formId}&limit=${pageSize}&skip=0&sort=-createdAt`,
  GET_CUSTOMER_PROJECTS: (page, pageSize, createdAt, projectName) =>
    `/api/admin/client/project/get?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}&search=${projectName}`,
  PROFILE_DETAILS: "/api/admin/client/auth/profile",
  KYC_DETAILS: "/api/admin/client/auth/kyc-details",
  GET_CUSTOMER_QUESTION_BANK: (page, pageSize, createdAt) =>
    `/api/admin/client/custom-section/get?limit=${pageSize}&skip=${(page - 1) * pageSize
    }&sort=${createdAt}`,
  UPDATE_CUSTOMER_STATUS: (id) => `/api/admin/customer/update/${id}/status`,
  CREATE_STANDARD_ASSIGN_FORM:
    "/api/admin/client/standard-assign-form-allotment/create",
  ALL_TICKETS: (pageNo, pageSize, status, searchTerm = "") =>
    `/api/admin/support/list?pageNo=${pageNo}&pageSize=${pageSize}&status=${status}&search=${encodeURIComponent(
      searchTerm
    )}`,
  CREATE_DYNAMIC_ASSIGN_FORM:
    "/api/admin/client/custom-assign-form-allotment/create",
  USERS_GETALL: (pageSize, pageNo, searchTerm, filter = {}) =>
    `/api/emp/auth/get?pageSize=${pageSize}&pageNo=${pageNo}&search=${searchTerm || ""}&filter=${encodeURIComponent(
      JSON.stringify(filter))}`,
  GET_CUSTOMER_USERS: `/api/admin/client/employee/get`,
  GET_ALL_CUSTOMER_USER: (page, pageSize, createdAt, clientId, searchTerm = "", filterData = {}) => {
    const cleanFilter = Object.fromEntries(
      Object.entries(filterData || {}).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
    );
    const params = new URLSearchParams({
      client_id: clientId,
      limit: pageSize,
      search: searchTerm || "",
      skip: (page - 1) * pageSize,
      sort: createdAt,
      ...cleanFilter
    });
    return `/api/admin/client/project/getUser?${params.toString()}`;
  },

  ALL_CUSTOMER_TICKETS: "/api/admin/client/support/all-ticket",
  ADD_CUSTOMER_USER: "/api/admin/client/employee/add-employee",
  GET_CUSTOMER_ROLES: (pageNo, pageSize, clientId) =>
    `/api/admin/client/emp-access/list?pageNo=${pageNo}&pageSize=${pageSize}&client_id=${clientId}`,
  ADD_CUSTOMER_ROLE: "/api/admin/client/emp-access/create",
  DELETE_CUSTOMER_ROLE: (id) => `/api/admin/client/emp-access/delete/${id}`,
  GET_CUSTOMER_ROLE_BY_ID: (id) => `/api/admin/client/emp-access/details/${id}`,
  EDIT_CUSTOMER_ROLE_BY_ID: (id) => `api/admin/client/emp-access/edit/${id}`,
  CREATE_CUSTOMER_SECTION: "/api/admin/client/custom-section/create",
  UPDATE_CUSTOMER_SECTION: (sectionId) =>
    `/api/admin/client/custom-section/update/${sectionId}`,
  CUSTOMER_SECTION_STATUS_CHANGE: (sectionId) =>
    `/api/admin/client/custom-section/update-status/${sectionId}`,
  CREATE_CUSTOMER_SUBSECTION: "/api/admin/client/custom-subsection/create",
  GET_CUSTOMER_ALL_CUSTOM_QUESTION: (page, search, filterData) =>
    `/api/admin/client/customQuestions/all?page=${page}&search=${search}&filter=${encodeURIComponent(
      JSON.stringify(filterData || {})
    )}`,
  GET_CUSTOMER_SETUP_DATA: (client_id) => `/api/admin/customersetup-update/get?client_id=${client_id}`,
  PUT_CUSTOMER_UPDATE_ACCESS: (client_id) =>
    `/api/admin/customersetup-update/access?client_id=${client_id}`,
  ADD_CUSTOMER_SUB_ADMIN_LICENSE: (id) => `/api/admin/customer/${id}/sub-admin-license`,
  ADD_CUSTOMER_MANAGEMENT_VIEW_LICENSE: (id) => `/api/admin/customer/${id}/management-view-license`,
  CREATE_CUSTOMER_QUESTION: `/api/admin/client/customQuestions/create`,
  GET_CUSTOMER_SUBSECTION: (sectionId) =>
    `/api/admin/client/custom-subsection/getByCustomSection/${sectionId}`,

  UPDATE_CUSTOMER_USER: (id) => `/api/admin/client/employee/update/${id}`,
  UPDATE_CUSTOMER_SUBSECTION: (subSectionId) =>
    `/api/admin/client/custom-subsection/update/${subSectionId}`,
  CREATE_CUSTOMER_DYNAMIC_FORM: "/api/admin/client/custom-form/create",
  COPY_CUSTOMER_DYNAMIC_FORM: (id) =>
    `/api/admin/client/custom-form/copy/${id}`,

  CREATE_CUSTOMER_PROJECT: "/api/admin/client/project/create",
  GET_CUSTOMER_FILTERED_PROJECTS: (limit, skip, sort, search, filterData) =>
    `/api/admin/client/project/get?limit=${limit}&skip=${skip}&sort=${sort}&search=${encodeURIComponent(
      search
    )}&filter=${encodeURIComponent(
      JSON.stringify(filterData)
    )}`,
  TICKET_DETAILS: (ticket_id) => `/api/admin/support/ticket/${ticket_id}`,
  TICKET_REPLY: "/api/admin/support/reply/ticket",
  SUBMIT_QUESTION: (formId) => `/api/admin/form-template/questions/${formId}`,

  GET_MY_PROFILE_DATA: "/api/admin/profile/user-details",
  RESET_PASSWORD: "/api/admin/profile/reset-password",

  POSTALLQUESTIONS: "/api/emp/standard-assign-form-allotment-answer/create",
  GET_ANSWERS: "/api/emp/standard-assign-form-allotment-answer/get-answers",

  REGISTER_AND_ASSIGN_GROUP_USER: "/api/admin/group/register-and-assign",
  GET_ALL_USERS_BY_CLIENTID: (clientId) =>
    `/api/admin/group/${clientId}/view-access-holders`,
  // GET_ALL_USERS_BY_CLIENTID: (clientId, pageSize, page, createdAt, search) =>
  //   `/api/admin/project/getUser?client_id=${clientId}&limit=${pageSize}&search=${search}&skip=${(page - 1) * pageSize
  //   }&sort=${createdAt}&`,

  // Group API's
  GET_ALL_GROUPS: (pageNo, pageSize, search = "") =>
    `/api/admin/group/list?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`,
  GET_GROUP_BY_ID: (id) => `/api/admin/group/get/${id}`,
  CREATE_GROUP: "/api/admin/group/create",
  UPDATE_GROUP: (id) => `/api/admin/group/update/${id}`,
  UPDATE_GROUP_STATUS: (id) => `/api/admin/group/update/${id}/status`,
  DELETE_GROUP: (id) => `/api/admin/group/delete/${id}`,
  ASSIGN_CLIENT_TO_GROUP: "/api/admin/group/assign-client",
  GET_ALL_CLIENT_UNDER_GROUP: (id) => `/api/admin/group/${id}/clients`,
  DELETE_GROUP_CLIENT: (id) => `/api/admin/group/assignment/${id}`,
  GRANT_VIEW_ACCESS: (id) => `/api/admin/group/${id}/grant-view-access`,
  REVOKE_VIEW_ACCESS: (id) => `/api/admin/group/${id}/revoke-view-access`,
  UPLOAD_GROUP_DOCUMENT: (id) => `/api/admin/group/upload-documents/${id}`,
  GET_GROUP_DOCUMENTS: (id) => `/api/admin/group/documents/${id}`,
  DELETE_GROUP_DOCUMENT: (id, docId) => `/api/admin/group/${id}/document/${docId}`,

  // Customer Document API's
  UPLOAD_CUSTOMER_DOCUMENT: (id) => `/api/admin/customer/upload-documents/${id}`,
  GET_CUSTOMER_DOCUMENTS: (id) => `/api/admin/customer/documents/${id}`,
  DELETE_CUSTOMER_DOCUMENT: (id, docId) => `/api/admin/customer/${id}/document/${docId}`,

  // Customer Detail API's
  GET_CUSTOMER_BY_ID: (id) => `/api/admin/customer/get/${id}`,
  UPDATE_CUSTOMER_PROFILE: (id) => `/api/admin/customer/profile/${id}`,
  UPLOAD_CUSTOMER_ORG_DOCUMENT: (id) => `/api/admin/customer/profile/${id}`,

  // Customer OTP API's
  CUSTOMER_SEND_OTP: (id) => `/api/admin/customer/otp/send/${id}`,
  CUSTOMER_VERIFY_OTP_NEW: (id) => `/api/admin/customer/otp/verify/${id}`,
  GET_GROUP_UNDER_CLIENT: (id) => `/api/admin/customer/group/${id}`,
  MANAGE_GROUP_LICENSE: (id) => `/api/admin/group/${id}/license`,
  //License Detail (STATIC NEED TO CHANGE)
  GET_ALL_LICENSES:"/Data/licenseSample.json",
  GET_LICENSES_CUSTOMER:"/Data/licenseCustomer.json",
  USER_CSV_UPLOAD:"/api/admin/project/csv/parse",
  VALIDATE_MAPPING:"/api/admin/project/csv/validate-mapping",
  BULK_UPLOAD:"/api/admin/project/csv/import-with-mapping",
  CSV_PARSE: (userId) => `/api/admin/customer/${userId}/csv/parse`,
  CSV_VALIDATE: (userId) => `/api/admin/customer/${userId}/csv/validate`,
  CSV_IMPORT: (userId) => `/api/admin/customer/${userId}/csv/import`,
  LOCATION_CSV_PARSE: (userId) => `/api/admin/customer/${userId}/location/csv/parse`,
  LOCATION_CSV_VALIDATE: (userId) => `/api/admin/customer/${userId}/location/csv/validate`,
  LOCATION_CSV_IMPORT: (userId) => `/api/admin/customer/${userId}/location/csv/import`,
  GET_ADDED_LOCATION:(id)=>`/api/admin/customer/${id}/location`,
  CREATE_LOCATION:(id)=>`/api/admin/customer/${id}/location`,
  UPDATE_LOCATION: (locationId) => `/api/admin/customer/location/${locationId}`,
  DELETE_LOCATION: (id, locationId) => `/api/admin/customer/${id}/location/${locationId}`,
  GET_DEPARTMENT:(id)=>`/api/admin/customer/${id}/department`,
  CREATE_DEPARTMENT:(id)=>`/api/admin/customer/${id}/department`,
  UPDATE_DEPARTMENT: ( departmentId) => `/api/admin/customer/department/${departmentId}`,
  DELETE_DEPARTMENT: (id) => `/api/admin/customer/department/${id}`,
//GET DEPARTMENT UNDER CLIENT
  GET_DEPARTMENTS: (departmentId, userId) => `/api/admin/customer/${userId}/org-mapping/linked/${departmentId}`,
  GET_LINKED: (id, customerId) => `/api/admin/customer/${customerId}/org-mapping/linked/${id}`,
  GET_UNLINKED: (id) => `/api/admin/customer/${id}/org-mapping/unlinked`,
  CREATE_MAPPING: (id) => `/api/admin/customer/${id}/org-mapping/link`,
  GET_LOCATIONS_OF_CLIENT:(id) => `/api/admin/customer/${id}/location`,
  CREATE_LOCATION:(id)=>`/api/admin/customer/${id}/location`,
  DELETE_LOCATION:(locationId)=>`/api/admin/customer/location/${locationId}`,
  CSV_PARSE:(id)=>`/api/admin/customer/${id}/department/csv/parse`,
 
  LOCATION_CSV_PARSE:(id)=>`/api/admin/customer/${id}/location/csv/parse`,
  CSV_IMPORT:(id)=>`/api/admin/customer/${id}/department/csv/import-with-mapping`,
  LOCATION_CSV_IMPORT:(id)=>`/api/admin/customer/${id}/location/csv/import-with-mapping`,
  CUSTOMER_CSV_IMPORT:(id)=>`/api/admin/customer/${id}/customer/csv/import-with-mapping`,
  CUSTOMER_CSV_PARSE:(id)=>`/api/admin/customer/${id}/customer/csv/parse`,
  ORG_MODE: (id)=>`/api/admin/customer/${id}/org-mode`,
    GET_SUB_ADMINS: (id)=>`/api/admin/customer/${id}/sub-admin`,
  CREATE_SUB_ADMIN:(id)=>`/api/admin/customer/${id}/sub-admin/create`,
  UPDATE_SUB_ADMIN: (id, employeeId) =>`/api/admin/customer/${id}/sub-admin/` + employeeId,
  GET_ALL_LICENSES: "/Data/licenseSample.json",
  GET_LICENSES_CUSTOMER: "/Data/licenseCustomer.json",
  DELETE_SUB_ADMIN:(id, empId)=>`/api/admin/customer/${id}/sub-admin/${empId}`,
  UPDATE_SUB_ADMIN_LICENSE:(id)=>`/api/admin/project/update-license/${id}`,

  // Notifications API's
  GET_NOTIFICATIONS: (page, limit, isRead) => {
    const params = new URLSearchParams();
    if (page !== undefined && page !== null) params.append("page", page);
    if (limit !== undefined && limit !== null) params.append("limit", limit);
    if (isRead !== undefined && isRead !== null) params.append("isRead", isRead);
    return `/api/admin/notifications?${params.toString()}`;
  },
  GET_UNREAD_NOTIFICATION_COUNT: "/api/admin/notifications/unread-count",
  MARK_ALL_NOTIFICATIONS_READ: "/api/admin/notifications/read-all",
  MARK_NOTIFICATION_READ: (id) => `/api/admin/notifications/${id}/read`,
  DELETE_NOTIFICATION: (id) => `/api/admin/notifications/${id}`,
  GET_CUSTOMER_FORMS_BY_PROJECT_ID: (projectId, userId) => `/api/admin/project/standard-form-allotments/${userId}/${projectId}`,
  GET_ALL_SUBSCRIBERS: (page, limit, search = "") => `/api/admin/subscriber/all?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
};
              
